export const getAllSalesGroups = `
  query getAllSalesGroups {
    salesGroups {
      value: id
      label: name
    }
  }
`;
